export const ROOT_ATTRIBUTES_STATE = 'attributes';

export const INITIAL_STATE = {
  items: [],
  loading: false,
  isSecuredLoaded: false,
  secured: {},
  error: null
};
